import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeFromCart } from '../../api/cart/remove-from-cart';
import syncCartCache from './sync-cart-cache';

const useRemoveFromCart = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (materialId: number) => removeFromCart(materialId),
        onSuccess: (cart) => syncCartCache(queryClient, cart)
    });
};

export default useRemoveFromCart;
